import { logWarning } from '@databases/logs';

import { fetchConfluenceData, rejectOnError } from './fetch';

export async function addContentLabels(
  contentId: string,
  labels: string[]
): Promise<void> {
  if (labels.length === 0) {
    return;
  }

  await fetchConfluenceData(`/rest/api/content/${encodeURIComponent(contentId)}/label`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
    },
    body: JSON.stringify(labels.map((label) => ({ prefix: 'global', name: label }))),
  }).then(rejectOnError);
}

export async function removeContentLabel(
  contentId: string,
  label: string
): Promise<void> {
  await fetchConfluenceData(
    `/rest/api/content/${encodeURIComponent(contentId)}/label?${new URLSearchParams({
      name: label,
    })}`,
    {
      method: 'DELETE',
    }
  ).then(rejectOnError);
}

export const autoCompleteLabel = async (query: string): Promise<string[]> => {
  const response = await fetchConfluenceData(
    `/labels/autocompletelabel.action?${new URLSearchParams({
      query,
    })}`
  );

  if (!response.ok) {
    logWarning(
      new Error('Could not autocomplete labels', {
        cause: `Request failed: ${response.url}. Status: ${response.status}.`,
      })
    );
    return [];
  } else {
    const data = await response.json();
    return (data.contentNameMatches as any[][]).flatMap((m) => m.map((l) => l.name));
  }
};
